import plasticImage from "../../../../static/process3.jpeg";
import React from "react";
import styles from "./style.module.scss";
import FeedIn from "../../../components/FramerMotion/FeedIn";

const ImageArea = () => {
  return (
    <div className={styles.imageArea}>
      <FeedIn>
        <img src={plasticImage} className={styles.image} />
      </FeedIn>
    </div>
  );
};

export default ImageArea;
